<template>
  <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="20" y="20" width="80" height="80" rx="8" fill="#F5F5F5" stroke="#E0E0E0" stroke-width="2"/>
    <path d="M40 40H80C82.2091 40 84 41.7909 84 44V76C84 78.2091 82.2091 80 80 80H40C37.7909 80 36 78.2091 36 76V44C36 41.7909 37.7909 40 40 40Z" fill="#E8E8E8"/>
    <path d="M50 50H70C71.1046 50 72 50.8954 72 52V68C72 69.1046 71.1046 70 70 70H50C48.8954 70 48 69.1046 48 68V52C48 50.8954 48.8954 50 50 50Z" fill="#D0D0D0"/>
    <path d="M55 55H65" stroke="#A0A0A0" stroke-width="1.5" stroke-linecap="round"/>
    <path d="M55 60H65" stroke="#A0A0A0" stroke-width="1.5" stroke-linecap="round"/>
    <path d="M55 65H65" stroke="#A0A0A0" stroke-width="1.5" stroke-linecap="round"/>
    <circle cx="60" cy="60" r="15" fill="#FF6B6B" stroke="#FF5252" stroke-width="2"/>
    <path d="M60 55V65M55 60H65" stroke="white" stroke-width="2" stroke-linecap="round"/>
  </svg>
</template> 